<div class="container mt-card">
  <div class="">
    <div class="card">

      <h3 class="text-center">CANDIDATE PROFILE</h3>
      <div class="well well-ss top-liner no-border-radius p-2">

        <div class="row">
          <div class="col-xs-10 col-xs-offset-1">
            <div style="margin: 10px auto;" class="text-center">
              <div *ngIf="!isNewCandidate">
                <div class="">
                  <img #passportPix src="assets/img/dp.png" alt="Passport Photo"
                    style="width: 20%;height: 15rem;border-radius: 3px;object-fit: fill;">
                </div>

                <div class="mt-2" style="display: flex;align-content: left;justify-content: left;" *ngIf="!hasPassort">
                  <span (click)="uploadPassport()" class="btn btn-success pt-0 pb-0 mr-4">Upload</span>
                  <input type="file" class="cursorP" accept=".png,.jpeg,.jpg" (change)="onPassportFileChange($event)">
                </div>
                <div class="mt-3 d-flex justify-content-left">
                  <span>Candidate Number: <b>{{candidate.examNo}}</b></span>
                </div>
              </div>


              <div class="d-flex justify-content-end" *ngIf="!isNewCandidate">
                <mat-icon class="icon-lg primaryColor cursorP" svgIcon="mat:edit" data-toggle="tooltip"
                  data-placement="top" title="Edit Form" (click)="editForm()"></mat-icon>

              </div>
            </div>
          </div>
        </div>

        <form (submit)="SaveCandidate()">

          <!-- First last and other Names -->
          <div class="row row-cols-3">
            <div class="col" *ngIf="isNewCandidate">
              <div class="form-group">
                <label>Candidate Number</label>
                <input type="text" class="form-control" placeholder="Candidate Number" [(ngModel)]="candidate.examNo"
                  [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>First Name</label>
                <input type="text" class="form-control" placeholder="First Name" required
                  [(ngModel)]="candidate.firstName" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Last Name</label>
                <input type="text" class="form-control" placeholder="Last Name" required
                  [(ngModel)]="candidate.lastName" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Other Names</label>
                <input type="text" class="form-control" placeholder="Other Names" required
                  [(ngModel)]="candidate.otherNames" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Mobile Number</label>
                <input type="tel" class="form-control" placeholder="Mobile Number" required
                  [(ngModel)]="candidate.mobileNo" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Email Address</label>
                <input type="text" class="form-control" placeholder="Email Address" required
                  [(ngModel)]="candidate.emailAddress" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Gender</label>
                <ng-select class="form-select" [(ngModel)]="candidate.gender" [ngModelOptions]="{ standalone: true }"
                  [disabled]="isReadonly">
                  <ng-option selected value="" disabled>Select Format</ng-option>
                  <ng-option value="NotSet">NotSet</ng-option>
                  <ng-option value="Male">Male</ng-option>
                  <ng-option value="Female">Female</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Extra Field 1</label>
                <input type="text" class="form-control" placeholder="Extra Field 1" required
                  [(ngModel)]="candidate.extraField1" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Extra Field 2</label>
                <input type="text" class="form-control" placeholder="Extra Field 2" required
                  [(ngModel)]="candidate.extraField2" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label>Extra Field 3</label>
                <input type="text" class="form-control" placeholder="Extra Field 3" required
                  [(ngModel)]="candidate.extraField3" [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
              </div>
            </div>
            <div class="col">
              <div class="form-group" style="display: contents;margin-top: 20px;">
                <div class="custom-control custom-checkbox">
                  <input id="requireScreenReaderInput" type="checkbox" class="custom-control-input"
                    [(ngModel)]="candidate.requiresScreenReader" [ngModelOptions]="{ standalone: true }"
                    [disabled]="isReadonly">
                  <label class="custom-control-label" for="requireScreenReaderInput">Requires Screen Reader</label>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group" style="display: contents;margin-top: 20px;">
                <div class="custom-control custom-checkbox">
                  <input id="skipAIFaceMatchingInput" type="checkbox" class="custom-control-input"
                    [(ngModel)]="candidate.skipAIFaceMatching" [ngModelOptions]="{ standalone: true }"
                    [disabled]="isReadonly">
                  <label class="custom-control-label" for="skipAIFaceMatchingInput">Skip AI Face Matching</label>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group" style="display: contents;margin-top: 20px;">
                <div class="custom-control custom-checkbox">
                  <input id="unlockPassportPhotoInput" type="checkbox" class="custom-control-input"
                    [(ngModel)]="candidate.unlockPassportPhoto" [ngModelOptions]="{ standalone: true }"
                    [disabled]="isReadonly">
                  <label class="custom-control-label" for="unlockPassportPhotoInput">Unlock Passport Photo</label>
                </div>
              </div>
            </div>
            <div class="col">
                <div class="form-group"  style="display: contents;margin-top: 20px;">
                  <div class="custom-control custom-checkbox">
                    <input id="testCandidate" type="checkbox" class="custom-control-input" [(ngModel)]="candidate.testCandidate"
                      [ngModelOptions]="{ standalone: true }" [disabled]="isReadonly">
                    <label class="custom-control-label" for="testCandidate">
                      Test Candidate
                    </label>
                    
                  </div>
                </div>
            </div>
          </div>

          <div class="d-flex justify-content-center" *ngIf="!isReadonly"  style="display: contents;margin-top: 20px;">
            <button type="submit" class="btn btn-primary btn-lg col-md-6">
              <mat-icon class="icon-sm cursorP pt-1 mr-1" svgIcon="mat:save" data-toggle="tooltip" data-placement="top"
                title="Save Form"></mat-icon>Save
            </button>
          </div>
        </form>

      </div>

    </div>

  </div>
</div>